/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import styled from 'styled-components';

interface IErrorComponent {
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
}

export const ErrorComponent = styled.div<IErrorComponent>`
  width: 100%;
  height: 12px;
  display: flex;
  align-self: flex-start;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};

  margin: 7px 0px;
  padding: 0px 14px;
`;

export const TextError = styled.span`
  font-style: italic;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: ${({ theme }) => theme.colors.error};
`;
